export default __webpack_public_path__ + "static/media/Group 10666.b49332af.svg";